import { createFileRoute } from '@tanstack/react-router';

import { CardEmbed, parseThemeParam } from '../embed/card-embed';

/**
 * `/embed/card?theme=<hex>` — the card form alone, for the mobile app's WebView (M18.2).
 * See `embed/card-embed.tsx` for the message shape and why no draft is needed.
 */

interface EmbedCardSearch {
  theme?: string;
}

export const Route = createFileRoute('/embed/card')({
  /* Only a valid `#rrggbb` survives; anything else is dropped here, before render. */
  validateSearch: (search: Record<string, unknown>): EmbedCardSearch => {
    const theme = parseThemeParam(search['theme']);
    return theme === null ? {} : { theme };
  },
  component: EmbedCardRoute,
});

function EmbedCardRoute() {
  const { theme } = Route.useSearch();
  return <CardEmbed theme={theme ?? null} />;
}
